import axios from 'axios';
import { isEmpty } from 'lodash';

import veritoneApi from './veritoneApi';

export function getScheduleReportsApi(urlApi, query) {
  let queryString = '';
  if (!isEmpty(query)) {
    queryString = new URLSearchParams(query).toString();
  }
  return veritoneApi(urlApi.baseUrl)
    .get(`${urlApi.report}?${queryString}`)
    .then(response => response.data)
    .catch(error => ({
      error: true,
      ...error
    }));
}

export function deleteReportApi(urlApi, scheduleInfo) {
  const { reportId } = scheduleInfo;
  return veritoneApi(urlApi.baseUrl)
    .delete(`${urlApi.report}/${reportId}`)
    .then(response => response.data)
    .catch(error => ({
      error: true,
      ...error
    }));
}

export function createScheduleReportApi(urlApi, data) {
  return veritoneApi(urlApi.baseUrl)
    .post(`${urlApi.report}/`, data)
    .then(response => response.data)
    .catch(error => ({
      error: true,
      ...error
    }));
}

export function updateScheduleReportApi(urlApi, scheduleInfo) {
  const { reportId } = scheduleInfo || {};
  return veritoneApi(urlApi.baseUrl)
    .put(`${urlApi.report}/${reportId}`, scheduleInfo)
    .then(response => {
      return response.data;
    })
    .catch(error => ({
      error: true,
      ...error
    }));
}

export function updateReportApi(urlApi, reportInfo) {
  const { reportId } = reportInfo;
  return veritoneApi(urlApi.baseUrl)
    .put(`${urlApi.report}/${reportId}`, reportInfo)
    .then(response => {
      return response.data;
    })
    .catch(error => ({
      error: true,
      ...error
    }));
};

export function getUnsubscribeScheduleReport(urlApi, token) {
  return axios({
    method: 'GET',
    url: `${urlApi.baseUrl}/unsubscribe/schedule-report`,
    headers: {
        "Content-Type": 'application/json',
        "token": token
    }
  });
}

export function unsubscribeScheduleReport(urlApi, token) {
  return axios({
    method: 'PUT',
    url: `${urlApi.baseUrl}/unsubscribe/schedule-report`,
    headers: {
        "Content-Type": 'application/json',
        "token": token
    }
  })
}

export function getUnsubscribeEmail(urlApi, subscriberToken) {
  return veritoneApi(urlApi.baseUrl)
    .get(`/unsubscribe/check_unsubscribe/${subscriberToken}`)
    .then(response => response.data)
    .catch(error => ({
      error: true,
      ...error
    }));
}

export function unsubscribeFeatureEmail(urlApi, subscriberToken) {
  return veritoneApi(urlApi.baseUrl)
    .get(`/unsubscribe/save_unsubscribe/${subscriberToken}`)
    .then(response => response.data)
    .catch(error => ({
      error: true,
      ...error
    }));
}